import { render, staticRenderFns } from "./DscMenu.vue?vue&type=template&id=514eff0e&"
import script from "./DscMenu.vue?vue&type=script&lang=js&"
export * from "./DscMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports